import React, { useState } from 'react';
import axios from 'axios';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import { Box, Typography, Stack, Button } from '@mui/material';
import { API_URL } from 'links/API_LINKS';
import CenturyLabForm from './CenturyLabForm';
import { useQueryClient } from 'react-query';

const EditCenturyTemplates = ({ setProjectToEdit, projectToEdit }) => {
  const queryClient = useQueryClient();
  const [serverResponse, setServerResponse] = useState();

  const tasks =
    projectToEdit.tasks && projectToEdit.tasks.length
      ? projectToEdit.tasks
      : [
          {
            skillId: [],
            learningOutcomes: '',
            backgroundDescription: '',
            taskInstructions: '',
            resources: '',
            // level: 'Basic',
            day: '',
            week: '',
            duration: '',
          },
        ];

  return (
    <Box>
      <Button onClick={() => setProjectToEdit(null)}>Back</Button>
      <Box>
        <Formik
          enableReinitialize={true}
          initialValues={{
            projectTemplateId: projectToEdit._id,
            title: projectToEdit.title,
            level: projectToEdit.level || '',
            type: projectToEdit.type,
            introduction: projectToEdit.introduction || '',
            template: projectToEdit.template || {
              link: '',
              description: '',
            },
            journeyType: projectToEdit.journeyType || [],
            tasks: tasks,
          }}
          validationSchema={Yup.object({
            title: Yup.string().required('Title is required'),
            level: Yup.string().required('Difficulty Level is required'),
            tasks: Yup.array().of(
              Yup.object().shape({
                learningOutcomes: Yup.string().required(
                  'Learning Outcomes is required'
                ),
                taskInstructions: Yup.string().required(
                  'Instructions is required'
                ),
                skillId: Yup.array().min(1, 'Minimum 1 skill required'),
                day: Yup.number().required(),
                week: Yup.number().required(),
                duration: Yup.number().required(),
              })
            ),
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setServerResponse('');
            axios({
              method: 'PUT',
              url: API_URL + '/project-template',
              data: values,
            })
              .then(function (response) {
                setServerResponse('Project updated');
                queryClient.invalidateQueries('fetchProjectTemplate');
                resetForm();
                setSubmitting(false);
                setProjectToEdit(null);
              })
              .catch(function (response) {
                setServerResponse('Error! Could not process your request.');
                setSubmitting(false);
              });
          }}
        >
          {({ values, setFieldValue, isSubmitting, errors }) => (
            <Form>
              <CenturyLabForm
                values={values}
                setFieldValue={setFieldValue}
                errors={errors}
                projectTaskToEdit={projectToEdit}
              />
              <Stack
                direction='row'
                justifyContent='center'
                alignItems='center'
                spacing={3}
                mt={2}
              >
                <LoadingButton
                  type='submit'
                  variant='contained'
                  loading={isSubmitting}
                  disabled={isSubmitting}
                >
                  Update Project
                </LoadingButton>
              </Stack>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  p: 1,
                  m: 1,
                }}
              >
                {serverResponse && <Typography>{serverResponse}</Typography>}
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default EditCenturyTemplates;
